import React, { useState, useEffect } from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import calc from "../../../utils/calculation";

import lbl from "../../../data/Labels.json";

const ContractsList = ({ data }) => {
  const columns = [
    { path: "id", label: "شماره" },
    // { path: "salary_id", label: "" },
    { path: "salary_per_month", label: "معاش ماهانه" },
    { path: "contract_start_date", label: "تاریخ شروع" },
    { path: "contract_end_date", label: "تاریخ ختم" },
    { path: "inserted_by", label: "ثبت کننده" },
    {
      path: "option",
      content: (e) => (
          <Option
              Edit={{ form: "staff-contract-form", cache: e.staff, edit: e }}
              Delete={{ route: "staff/contracts", id: e.salary_id }}
          />
      ),
    },
  ];

  // if (data?.data && data?.summary) {
  //   data.summary.salary_per_month = calc.getTotal(data.data, "salary_per_month");
  // }

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Contracts}</p>
      <Table
        data={data}
        columns={columns}
      />
    </div>
  );
};

export default ContractsList;
